<template>
  <div v-if="post" class="shadow-card p-0">
    <p class="card_info">
      <span class="bold">{{ post.reaction.flag }}{{ post.reaction.flag > 1 ? " users" : " user" }}</span>
      reported this<span class="bold"> {{ post.hasOwnProperty("is_comment") ? "Comment" : postTypeString(post.content_type) }}.</span>
    </p>
    <a-divider type="horizontal" class="m-0" />
    <div v-if="post.hasOwnProperty('sponsered') && post.sponsered.length" class="promoted-post-head" :style="{ background: getPrimary50Color() }">
      <font-awesome-icon :icon="['fas', 'bullhorn']" class="" :style="{ height: '15px', width: '15px', color: getPrimaryColor() }" />
      <div class="ml-1" :style="{ color: getPrimaryColor() }">PROMOTED</div>
    </div>
    <div class="p-3">
      <div class="post-head position-relative mb-2">
        <div class="title cp" @click="() => viewProfile(post)">
          <a @click="() => viewProfile(post)" href="#">
            <a-avatar
              class="post-list-image text-capitalize"
              :style="{
                color: '#ffffff',
                'background-color': post.hasOwnProperty('sponsered') && post.sponsered.length ? post.sponsered[0].url : post.user[0].url ? post.user[0].url : getAvatarColor(post.user[0].id),
              }"
              :size="70"
              :src="authUser.user.id === post.user[0].id ? authUser.user.url : post.hasOwnProperty('sponsered') && post.sponsered.length ? post.sponsered[0].url : post.user[0].url"
              alt="avatar"
            >
              {{ getPostUserInitials(post) }}
            </a-avatar>
          </a>
        </div>
        <div class="my-auto cp" @click="() => viewProfile(post)">
          <div v-if="post.hasOwnProperty('sponsered') && post.sponsered.length">
            <p class="m-0 p-0 cp">
              {{ post.sponsered[0].name.charAt(0).toUpperCase() + post.sponsered[0].name.slice(1) }}
            </p>
          </div>
          <template v-else>
            <div class="d-flex align-items-center name-with-feeling pr-3 flex-wrap">
              <p class="m-0 p-0 cp text-capitalize" @click="() => viewProfile(post)" v-if="post.user[0].role === 'patient' || post.user[0].role === 'caregiver'">
                {{ post.user[0].display_name }}
              </p>
              <p
                class="m-0 p-0 cp text-capitalize"
                @click="() => viewProfile(post)"
                v-if="
                  post.user[0].role === 'hospital_administrator' ||
                  post.user[0].role === 'clinic_administrator' ||
                  post.user[0].role === 'nfp_administrator' ||
                  post.user[0].role === 'business_administrator'
                "
              >
                {{ post.user[0].display_name }}
              </p>
              <p class="m-0 p-0 cp text-capitalize" @click="() => viewProfile(post)" v-if="post.user[0].role === 'advocate'">
                {{ post.user[0].display_name || "A" }}
              </p>
              <p class="m-0 cp text-capitalize p-0" @click="() => viewProfile(post)" v-if="post.user[0].role === 'admin'">
                {{ post.user[0].display_name.charAt(0).toUpperCase() + post.user[0].display_name.slice(1) || "DoveMedAdmin" }}
              </p>
              <p class="m-0 p-0 cp text-capitalize" @click="() => viewProfile(post)" v-if="post.user[0].role === 'doctor' || post.user[0].role === 'physician' || post.user[0].role === 'hcp'">
                {{ post.user[0].display_name ? post.user[0].display_name[0].toUpperCase() + post.user[0].display_name.slice(1) : "Dr." }}
              </p>
              <p class="m-0 p-0 sub-text ml-2 d-flex fw400" v-if="post.day_type">
                was feeling
                {{ post.day_type.split(" ").reverse()[0].toLowerCase() }}
                <img :src="getPostEmoji()" class="hw24 ml-1 my-auto" alt="image" />
              </p>
              <p class="m-0 p-0 sub-text ml-2 d-flex fw400" v-else-if="post.celebration_type">
                was celebrating {{ post.celebration_type }}
                <img :src="require(`../../../assets/emojis/confetti-24.png`)" class="hw24 ml-2 my-auto" alt="image" />
              </p>
              <div v-if="post.content_type === 'job'" class="ml-2 gray900 d-flex align-items-center sub-text">
                <img :src="require(`../../../assets/emojis/briefcase-72.png`)" class="hw18 mr-2" alt="image" />
                Shared a job opening
              </div>
              <div v-if="post.content_type === 'event'" class="ml-2 gray900 d-flex align-items-center sub-text">
                <img :src="require(`../../../assets/emojis/calendar-72.png`)" class="hw18 mr-2" alt="image" />
                Created an event
              </div>
              <div v-if="post.content_type === 'poll'" class="ml-2 gray900 d-flex align-items-center sub-text">
                <font-awesome-icon size="1x" :icon="['fal', 'poll']" class="hw18 mr-2" />
                Created a poll
              </div>
              <div v-if="post.content_type === 'question'" class="ml-2 gray900 d-flex align-items-center sub-text">
                <font-awesome-icon size="1x" :icon="['fal', 'question-circle']" class="hw18 mr-2" />
                Asked a question
              </div>
              <div v-if="post.content_type === 'question'" class="ml-2 gray900 d-flex align-items-center sub-text">
                <font-awesome-icon size="1x" :icon="['fal', 'exchange']" class="hw18 mr-2" />
                {{ post.category.toLowerCase() }}
              </div>
              <div v-if="post.content_type === 'press' || post.content_type === 'pressRelease'" class="ml-2 gray900 d-flex align-items-center sub-text">
                <img :src="require(`../../../assets/emojis/newspaper-72.png`)" class="hw18 mr-2" alt="image" />
                Shared a press release
              </div>
            </div>

            <!-- ROLE TAGS -->
            <div class="post-physician py-1 px-2 turquoise-text turquoise-bg font12" v-if="post.user[0].role === 'admin'">DoveMed Admin</div>
            <div
              class="post-physician py-1 px-2 font12"
              :style="{
                color: getPrimaryColor(),
                background: getPrimary50Color(),
              }"
              v-if="post.user[0].role === 'caregiver'"
            >
              <font-awesome-icon :icon="['far', 'hands-heart']" class="mr-1" />
              Caregiver
            </div>
            <div class="" v-if="post.user[0].role === 'business_administrator'">
              <span class="post-physician py-1 px-2 orange-text orange-bg font12">
                <font-awesome-icon :icon="['far', 'store']" class="mr-1" />
                Business
              </span>
            </div>
            <div class="" v-if="post.user[0].role === 'hospital_administrator'">
              <span class="post-physician py-1 px-2 orange-text orange-bg font12">
                <font-awesome-icon :icon="['far', 'hospital-alt']" class="mr-1" />
                Hospital
              </span>
              <span class="font12 pl-1">
                {{ post.user[0].speciality }}
              </span>
            </div>
            <div class="" v-if="post.user[0].role === 'clinic_administrator'">
              <span class="post-physician py-1 px-2 orange-text orange-bg font12">
                <font-awesome-icon :icon="['far', 'hospital']" class="mr-1" />
                Clinic
              </span>
              <span class="font12 pl-1">
                {{ post.user[0].speciality }}
              </span>
            </div>
            <div class="p-0" v-if="post.user[0].role === 'doctor' || post.user[0].role === 'physician'">
              <span class="post-physician py-1 px-2 orange-bg orange-text font12">
                <font-awesome-icon :icon="['far', 'user-md']" class="mr-1" />
                Physician
              </span>
              <span class="font12 pl-1">
                {{ post.user[0].speciality }}
              </span>
            </div>
            <div class="p-0" v-if="post.user[0].role === 'hcp' || post.user[0].role === 'ohcp'">
              <span class="post-physician py-1 px-2 orange-bg orange-text font12">
                <font-awesome-icon :icon="['far', 'user-nurse']" class="mr-1" />
                Advanced Practice Provider
              </span>
              <span class="font12 pl-1">
                {{ post.user[0].speciality }}
              </span>
            </div>
            <div class="post-physician py-1 px-2 m-0 font12 orange-bg orange-text" v-if="post.user[0].role === 'nfp' || post.user[0].role === 'nfp_administrator'">
              <font-awesome-icon :icon="['far', 'hand-holding-heart']" class="mr-1" />
              Non For Profit
            </div>
            <div class="d-flex my-1" v-if="post.user[0].role === 'advocate'">
              <div
                class="post-physician py-1 px-2 font12"
                :style="{
                  color: getPrimaryColor(),
                  background: getPrimary50Color(),
                }"
              >
                <font-awesome-icon :icon="['fas', 'bullhorn']" class="mr-1" />
                Advocate
              </div>
              <div v-if="post.user[0].organization" class="bg-purple50 purple300 rounded fw700 font12 py-1 px-2 ml-2">Supporting {{ post.user[0].organization }}</div>
            </div>
          </template>
          <p class="posted mt-1">{{ post.is_edited ? "Edited: " : "" }}{{ formatPostTime(post.is_edited ? post.updated_at : post.post_time) }}</p>
        </div>
        <div style="flex: 1"></div>
        <!-- <a-icon
          type="more"
          :style="{
            alignSelf: 'center',
            padding: '5px',
            cursor: 'pointer',
          }"
        /> -->
      </div>
      <template v-if="post.content_type === 'post'">
        <div :class="`position-relative multiImgs ${post.post_attach_url.length === 2 ? 'two-image-grid' : 'more-image-grid'}`" v-if="post.post_attach_url && post.post_attach_url.length > 0">
          <div v-for="(image, ind) in post.post_attach_url" :key="image.name" :class="`position-relative ${post.post_attach_url.length === 2 && 'mb-3'} w-100 ${getClass(ind)}`">
            <template v-if="image.type">
              <img v-if="image.type.includes('image')" :src="image.resized_images ? image.resized_images.dov1280x720 : image.url" alt="image" />
              <video v-if="image.type.includes('video')" :src="image.url" controls />
            </template>
            <img v-else :src="image.resized_images ? image.resized_images.dov1280x720 : image.url" alt="image" />
            <div v-if="image.sensitive" class="position-absolute flex-center-center flex-column h-100 w-100" :style="{ background: getSecondaryColor(), top: 0 }">
              <font-awesome-icon :icon="['fas', 'eye-slash']" class="font-white hw54" />
            </div>
            <div v-if="ind === 2 && post.post_attach_url.length > 3" class="more"></div>
            <span v-if="ind === 2 && post.post_attach_url.length > 3" class="moreText"> +{{ post.post_attach_url.length - 2 }} </span>
          </div>
        </div>
        <p class="mb-2" v-if="post.post_title">
          <b>{{ post.post_title }}</b>
        </p>
      </template>
      <p
        v-if="post.post_text"
        :style="{
          'white-space': 'pre-wrap',
          'margin-left': '-15px',
          overflow: 'hidden',
          height: seeMoreClicked ? 'auto' : '200px',
        }"
        class="content ql-editor post-description gray600"
        v-html="post.post_text"
        ref="postRef"
      ></p>
      <p class="mb-0 gray400 font14 mt-3 cp" @click="() => (seeMoreClicked = true)" v-if="!seeMoreClicked">See More</p>
      <NewEventData
        v-else-if="post.content_type === 'event'"
        :displayData="{
          img: post.event_attach_url || [],
          eventName: post.event_name,
          eventType: post.event_type,
          startDate: post.start_date,
          endDate: post.end_date,
          timeZone: post.time_zones || 'UTC - 00:00',
          link: post.event_link,
        }"
        :noOptions="true"
        :user="post.user[0].display_name"
      />
      <NewJobData
        v-else-if="post.content_type === 'job'"
        :displayData="{
          img: post.job_attach_url || [],
          jobTitle: post.job_title,
          company: post.company_name,
          city: post.location.city,
          state: post.location.state,
          workType: post.workplace_type,
          des: post.job_description,
          link: post.job_link,
        }"
        :noOptions="true"
      />
      <NewPressReleaseData
        v-else-if="post.content_type === 'press'"
        :displayData="{
          img: post.press_attach_url || [],
          subject: post.press_subject,
          des: post.press_description,
          link: post.press_link,
        }"
        :noOptions="true"
      />
      <!-- poll -->
      <div v-if="post.content_type === 'poll'">
        <div v-if="post.poll_attach && post.poll_attach.length">
          <img
            :src="post.poll_attach && post.poll_attach[0] ? (post.poll_attach[0].resized_images ? post.poll_attach[0].resized_images.dov1280x720 : post.poll_attach[0].url) : ''"
            :style="{
              width: '100%',
              height: '100%',
              'object-fit': 'contain',
              'max-height': '360px',
            }"
            :alt="post.poll_attach[0].name || 'poll_image'"
            class="mb-3 mt-2"
          />
        </div>
        <p
          :style="{
            'white-space': 'pre-wrap',
            'margin-left': '-15px',
          }"
          class="content ql-editor post-description gray900 fw700"
          v-html="post.poll_question"
        ></p>
        <div v-for="(options, index) in post.choices" v-bind:key="index" class="poll-tick">
          <span class="float-right" style="padding: 12px 24px" v-if="options.choice_vote">{{ options.choice_vote.toFixed(0) }} %</span>
          <span class="float-left" style="padding: 12px 24px">{{ options.poll_option }}</span>
          <div v-if="options.choice_vote" class="vote-percent" :style="{ background: '#A1BDE6', width: options.choice_vote + '%' }" />
        </div>
      </div>
      <!-- question -->
      <div v-if="post.content_type === 'question'">
        <b
          v-if="post.question"
          style="white-space: pre-wrap"
          class="mb-2 mt-2"
          :style="{
            'font-weight': '700',
            'font-size': ' 16px',
            'line-height': '24px',
            color: '#0F1734',
          }"
          v-html="post.question"
        ></b>
        <p v-if="post.question_description" style="white-space: pre-wrap" class="mt-2 post-description" v-html="post.question_description"></p>
        <div
          :class="`mt-2 position-relative multiImgs ${post.question_attach_url.length === 2 ? 'two-image-grid' : 'more-image-grid'}`"
          v-if="post.question_attach_url && post.question_attach_url.length > 0"
        >
          <div v-for="(image, ind) in post.question_attach_url" :key="image.name" :class="`position-relative  ${post.question_attach_url.length === 2 && 'mb-3'} w-100 ${getClass(ind)}`">
            <template v-if="image.type">
              <img v-if="image.type.includes('image')" :src="image.resized_images ? image.resized_images.dov1280x720 : image.url" alt="image" />
              <video v-if="image.type.includes('video')" :src="image.url" controls />
            </template>
            <img v-else :src="image.resized_images ? image.resized_images.dov1280x720 : image.url" alt="image" />
            <div v-if="image.sensitive" class="position-absolute flex-center-center flex-column h-100 w-100" :style="{ background: getSecondaryColor(), top: 0 }">
              <font-awesome-icon :icon="['fas', 'eye-slash']" class="font-white hw54" />
            </div>
            <div v-if="ind === 2 && post.question_attach_url.length > 3" class="more"></div>
            <span v-if="ind === 2 && post.question_attach_url.length > 3" class="moreText"> +{{ post.question_attach_url.length - 2 }} </span>
          </div>
        </div>
      </div>
      <!-- tags -->
      <div v-if="post.tags && post.tags.length" class="post__tags mt-3">
        <div
          v-for="(tag, index) in post.tags.slice(0, 3)"
          :key="index"
          class="tags rounded"
          :style="{
            color: getPrimaryColor(),
            background: getPrimary50Color(),
          }"
        >
          #{{ tag }}
        </div>
        <div v-if="post.tags.length > 3" class="popover-button">
          <a-popover placement="right">
            <template slot="content">
              <p
                v-for="(tag, index) in post.tags.slice(3)"
                :key="index"
                :style="{
                  color: getPrimaryColor(),
                  background: getPrimary50Color(),
                }"
                class="rounded p-1"
              >
                #{{ tag }}
              </p>
            </template>
            <button
              :style="{
                background: getPrimary50Color(),
                color: getPrimaryColor(),
                'font-size': '10px',
                'line-height': '20px',
              }"
              class="rounded"
            >
              +{{ post.tags.length - 3 }}
            </button>
          </a-popover>
        </div>
      </div>
    </div>
    <p v-if="!post.hasOwnProperty('is_comment')" class="comment_count">
      {{ post.hasOwnProperty("comment_count") ? (post.comment_count > 1 ? `${post.comment_count} comments` : `${post.comment_count} comment`) : "0 comment" }}
    </p>
    <a-divider type="horizontal" class="m-0" />
    <CommentsCard v-if="post.hasOwnProperty('is_comment') && post.commented_on_type === 2 && parentComment" :data="parentComment" />
    <div v-if="post.hasOwnProperty('is_comment')" :class="parentComment ? 'comment_container ml-5' : 'comment_container'">
      <div class="header">
        <a-avatar
          :style="{
            color: ' #ffffff !important',
            backgroundColor: post.comment_image ? '' : getAvatarColor(0),
            fontSize: '16px',
            fontWeight: '700',
          }"
          :src="post.comment_image"
          :size="40"
          class="text-capitalize cp"
        >
          {{ post.comment_name[0] }}
        </a-avatar>
        <div class="pl-2">
          <p class="name" style="flex: 1">{{ post.comment_name }}</p>
          <div class="d-flex align-items-center" style="gap: 5px">
            <div class="py-1" v-if="post.comment_role === 'hospital_administrator'">
              <span class="post-physician py-1 px-2 orange-text orange-bg font12">
                <font-awesome-icon size="1x" :icon="['far', 'hospital-alt']" class="mr-1" />
                Hospital
              </span>
              <span class="font12 pl-1">
                {{ post.comment_user.speciality }}
              </span>
            </div>
            <div class="py-1" v-if="post.comment_role === 'business_administrator'">
              <span class="post-physician py-1 px-2 orange-text orange-bg font12">
                <font-awesome-icon size="1x" :icon="['far', 'store']" class="mr-1" />
                Business
              </span>
            </div>
            <div class="" v-if="post.comment_role === 'clinic_administrator'">
              <span class="post-physician py-1 px-2 orange-text orange-bg font12">
                <font-awesome-icon size="1x" :icon="['far', 'hospital']" class="mr-1" />
                Clinic
              </span>
            </div>
            <div class="p-0" v-if="post.comment_role === 'doctor' || post.comment_role === 'physician'">
              <span class="post-physician py-1 px-2 orange-bg orange-text font12">
                <font-awesome-icon size="1x" :icon="['far', 'user-md']" class="mr-1" />
                Physician
              </span>
              <span class="font12 pl-1">
                {{ post.comment_user.speciality }}
              </span>
            </div>
            <div class="p-0" v-if="post.comment_role === 'hcp' || post.comment_role === 'ohcp'">
              <span class="post-physician py-1 px-2 orange-bg orange-text font12">
                <font-awesome-icon size="1x" :icon="['far', 'user-nurse']" class="mr-1" />
                Advanced Practice Provider
              </span>
              <span class="font12 pl-1">
                {{ post.comment_user.speciality }}
              </span>
            </div>
            <div class="post-physician p-1 pl-2 pr-2 mt-2 mb-2" v-if="post.comment_role === 'nfp'">Non For Profit</div>
            <div class="post-physician py-1 px-2 orange-bg orange-text font12" v-if="post.comment_role === 'advocate'">
              <div v-if="post.comment_user.organization">Supporting {{ post.comment_user.organization }}</div>
              <div v-else class="orange-text font12">
                <font-awesome-icon size="1x" :icon="['far', 'user-md']" class="mr-1" />
                Advocate for
                {{ currentCircle.condition_type.slice(0, 20) }}
                {{ currentCircle.condition_type.length > 20 ? "..." : "" }}
              </div>
            </div>
            <p class="posted">
              {{ formatPostTime(post.comment_time) }}
            </p>
          </div>
        </div>
        <div style="flex: 1"></div>
        <!-- <a-icon
          type="more"
          :style="{
            alignSelf: 'center',
            padding: '5px',
            cursor: 'pointer',
          }"
        /> -->
      </div>
      <p class="card_description pl-5 pt-3">
        {{ post.comment_text }}
      </p>
      <div v-for="image in post.comment_attach_url" :key="image.name">
        <img :src="image.resized_images ? image.resized_images.dov640x320 : image.url" :alt="image.name" width="50%" class="comment-image" />
      </div>
    </div>
    <div v-if="post.hasOwnProperty('is_comment') && seeFullThread && (post.comment_count || post.commented_on_type === 2)" class="full_thread_container">
      <p class="full_thread" :style="{ color: getPrimaryColor() }" @click="handleFullThread">See full thread</p>
    </div>
    <CommentsCard class="ml-5" v-if="post.hasOwnProperty('is_comment') && post.comment_count && comments.length" v-for="reply in comments" :key="reply.id" :data="reply" :parent="post.comment_name" />
    <div v-if="total_comments !== comments.length && !commentLoading" class="ml-5">
      <span @click="paginateComment" :style="{ cursor: 'pointer', color: getPrimaryColor() }"
        ><svg :style="{ fill: getPrimaryColor(), width: '20px' }" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="w20 mr-1">
          <path
            d="M366.4 414C357.7 410.2 352 401.5 352 392L352 303.1H80C35.87 303.1 0 268.1 0 223.1V48C0 39.16 7.156 32 16 32C24.84 32 32 39.16 32 48V223.1C32 250.5 53.53 271.1 80 271.1H352L352 184C352 174.5 357.7 165.8 366.4 162C375.2 158.2 385.3 159.9 392.3 166.4L504.3 270.4C509.4 275.2 512 281.6 512 287.1C512 294.4 509.4 300.8 504.3 305.6L392.3 409.6C385.3 416.1 375.2 417.8 366.4 414V414zM384 373.7L476.2 288L384 202.3V373.7z"
          /></svg>See {{ total_comments - comments.length }} More {{ total_comments - comments.length === 1 ? "Reply" : "Replies" }}</span
      >
    </div>
    <div v-if="commentLoading">
      <div class="d-flex justify-content-center mt-3">
        <div>
          <div class="spinner-border spinner-class"></div>
        </div>
        <div :style="{ 'margin-left': '-45px', 'margin-top': '40px' }">Loading...</div>
      </div>
    </div>
    <div class="card_footer">
      <a-button
        class="card_button"
        :style="{
          background: getPrimaryColor(),
        }"
        @click="handleKeepPost"
        :loading="loading"
      >
        Keep
      </a-button>
      <a-button class="card_button2" @click="handleRemovePost" :loading="removeLoading">
        <span style="color: #47556e !important">Remove</span>
      </a-button>
    </div>
  </div>
</template>

<script>
import { RepositoryFactory } from "../../../repositories/RepositoryFactory"
import NewEventData from "../createNewPost/data/Event.vue"
import NewJobData from "../createNewPost/data/Job.vue"
import NewPressReleaseData from "../createNewPost/data/PressRelease.vue"
import CommentsCard from "./CommentsCard.vue"

const UserRepository = RepositoryFactory.get("user")
const AboutCircleRepository = RepositoryFactory.get("aboutCircle")
const PostRepository = RepositoryFactory.get("post")

export default {
  name: "Reports",
  props: {
    post: Object,
    refresh: Function,
  },
  components: {
    NewJobData,
    NewPressReleaseData,
    NewEventData,
    CommentsCard,
  },
  data() {
    return {
      seeMoreClicked: false,
      seeFullThread: true,
      commentLoading: false,
      parentComment: null,
      comments: [],
      page: 1,
      total_comments: 0,
      loading: false,
      removeLoading: false,
      typesOfFeelings: [
        { name: "good", icon: "happy-40" },
        { name: "bad", icon: "bad-32" },
        { name: "okay", icon: "okay-32" },
        { name: "angry", icon: "angry-40" },
        { name: "Happy", icon: "happy-40" },
        { name: "Blessed", icon: "Blessed-24" },
        { name: "Loved", icon: "Loved-24" },
        { name: "Angry", icon: "angry-40" },
        { name: "Crazy", icon: "Crazy-24" },
        { name: "Amazing", icon: "Amazing-24" },
        { name: "Festive", icon: "Festive-24" },
        { name: "Tired", icon: "Tired-24" },
        { name: "Confident", icon: "Confident-24" },
        { name: "Hot", icon: "hot-24" },
        { name: "Cold", icon: "Cold-24" },
        { name: "Sick", icon: "Sick-24" },
        { name: "Speachless", icon: "Speachless-24" },
        { name: "Cool", icon: "Cool-24" },
        { name: "Scared", icon: "Scared-24" },
        { name: "Emotional", icon: "emotional-40" },
        { name: "Injured", icon: "Injured-24" },
        { name: "In Love", icon: "inlove-24" },
        { name: "Inlove", icon: "inlove-24" },
      ],
    }
  },
  created() {
    if (this.post && this.post.post_text) {
      if (this.post.post_text.length <= 200 || this.$el.querySelector(".ql-editor").scrollHeight <= 200) {
        this.seeMoreClicked = true
      }
    } else {
      this.seeMoreClicked = true
    }
  },
  methods: {
    handleFullThread() {
      this.seeFullThread = false
      if (this.post.commented_on_type === 2) {
        this.getParentComment()
      }
      if (this.post.comment_count) {
        this.getReplies()
      }
    },
    paginateComment() {
      this.page++
      this.getReplies()
    },
    getParentComment() {
      this.commentLoading = true
      AboutCircleRepository.getCommentDetails(this.post.commented_on_id)
        .then(res => {
          if (res.data.data.length) {
            this.parentComment = res.data.data[0]
          } else {
            this.parentComment = null
          }
          this.commentLoading = false
        })
        .catch(e => {
          this.commentLoading = false
        })
    },
    getReplies() {
      this.commentLoading = true
      AboutCircleRepository.getCommentReplies(this.post.comment_id, this.getUrl(), this.page, 1)
        .then(res => {
          const comments = res.data.message === "found" ? res.data.data.data : []
          this.comments.push(...comments)
          this.page = res.data.message === "found" ? parseInt(res.data.data.paginator.page_num) : this.page
          this.total_comments = res.data.message === "found" ? parseInt(res.data.data.paginator.total_count) : 0
          this.commentLoading = false
        })
        .catch(e => {
          this.commentLoading = false
        })
    },
    getUrl() {
      switch (this.post.content_type) {
        case "post":
          return "commentsonpostcomment"
        case "job":
          return "commentsjoblist"
        case "press":
          return "commentspresslist"
        case "event":
          return "commentseventlist"
        case "question":
          return "commentsonpostcomment"
        case "poll":
          return "commentspolllist"
        default:
          return "commentsonpostcomment"
      }
    },
    async handleKeepPost() {
      this.loading = true
      try {
        await AboutCircleRepository.keepReportedPost(this.currentCircle.id, this.post.reacted_on_id, this.post.reacted_on_type)
        console.log("INNN1")
        await this.refresh()
        console.log("INNN2")
        this.$notification.success({
          message: "Successful",
          description: `Keep ${this.post.hasOwnProperty("is_comment") ? "comment" : "post"} successful`,
        })
        console.log("INNN3")
        this.loading = false
      } catch (e) {
        this.loading = false
      }
    },
    async handleRemovePost() {
      this.removeLoading = true
      try {
        await AboutCircleRepository.removeReportedPost(this.currentCircle.id, this.post.reacted_on_id, this.post.reacted_on_type)
        await this.refresh()
        this.$notification.success({
          message: "Successful",
          description: `Removed ${this.post.hasOwnProperty("is_comment") ? "comment" : "post"} successfully`,
        })
        this.removeLoading = false
      } catch (e) {
        this.removeLoading = false
      }
    },
    viewProfile(post) {
      if (post.user[0].role === "admin") {
        return
      }
      this.loadingScreen = true
      const user = post.user[0]
      if (user.id === this.authUser.user.id && user.role === this.authUser.user.role) {
        this.routeToAuthProfile(this.authUser.user.role)
      } else {
        UserRepository.getOtherUserProfile(user, this.currentCircle.id)
          .then(res => {
            const data = {
              ...res.data.data.user_info,
              on_circle: res.data.data.on_circle,
              request_to_add: res.data.data.request_to_add,
              no_of_members: res.data.data.no_of_members,
              recommendations: res.data.data.no_of_recommendations,
              recommend: res.data.data.recommend,
              overall_rating: res.data.data.overall_rating ? res.data.data.overall_rating : res.data.data.rating,
              inPersonReview: res.data.data.in_person_visit,
              onlineReview: res.data.data.online_tele_medicine,
              myCirclesReview: res.data.data.my_circle,
            }
            this.$store.commit("User/setViewUser", { data })
            switch (user.role) {
              case "doctor":
              case "physician":
                this.$router.push({
                  name: "ViewDoctorUpdates",
                  params: { id: user.id },
                })
                break
              case "clinic_administrator":
                this.$router.push({
                  name: "ViewClinicAbout",
                  params: { id: user.id },
                })
                break
              case "hospital_administrator":
                this.$router.push({
                  name: "ViewHos_adminAbout",
                  params: { id: user.id },
                })
                break
              case "nfp":
                this.$router.push({
                  name: "ViewNfpAbout",
                  params: { id: user.id },
                })
                break
              case "patient":
                this.$router.push({
                  name: "ViewPatientUpdates",
                  params: { id: user.id },
                })
                break
              case "caregiver":
                this.$router.push({
                  name: "ViewPatientUpdates",
                  params: { id: user.id, role: 'caregiver' },
                })
                break
              case "advocate":
                this.$router.push({
                  name: "ViewAdvocateAbout",
                  params: { id: user.id },
                })
                break
              case "hospital":
                this.$router.push({
                  name: "HospViewAbout",
                  params: { id: user.id },
                })
                break
              case "clinic":
                this.$router.push({
                  name: "ClinicViewAbout",
                  params: { id: user.id },
                })
              case "nfp_administrator":
                this.$router.push({
                  name: "ViewNfpAdminAbout",
                  params: { id: user.id },
                })
                break
              default:
                break
            }
          })
          .catch(err => {})
      }
    },
    getPostUserInitials(post) {
      let f = "",
        l = ""
      if (post.hasOwnProperty("sponsered") && post.sponsered.length) {
        f = post.sponsered[0].name ? post.sponsered[0].name[0] : "S"
        l = post.sponsered[0].name.split(" ").slice(1).join(" ") ? post.sponsered[0].name.split(" ").slice(1).join(" ")[0] : ""
      } else {
        f = post.user[0].display_name ? post.user[0].display_name[0] : "D"
        l = post.user[0].display_name.split(" ").slice(1).join(" ") ? post.user[0].display_name.split(" ").slice(1).join(" ")[0] : ""
      }
      return f.toUpperCase() + l.toUpperCase()
    },
    formatPostTime(value) {
      const d = new Date(value)
      const now = new Date()
      const seconds = Math.round(Math.abs((now.getTime() - d.getTime()) / 1000))
      const minutes = Math.round(Math.abs(seconds / 60))
      const hours = Math.round(Math.abs(minutes / 60))
      const days = Math.round(Math.abs(hours / 24))
      const months = Math.round(Math.abs(days / 30.416))
      const years = Math.round(Math.abs(days / 365))
      if (Number.isNaN(seconds)) {
        return ""
      } else if (seconds <= 45) {
        return "a few seconds ago"
      } else if (seconds <= 90) {
        return "a minute ago"
      } else if (minutes <= 45) {
        return minutes + " minutes ago"
      } else if (minutes <= 90) {
        return "an hour ago"
      } else if (hours <= 22) {
        return hours + " hours ago"
      } else if (hours <= 36) {
        return "a day ago"
      } else if (days <= 25) {
        return days + " days ago"
      } else if (days <= 45) {
        return "a month ago"
      } else if (days <= 345) {
        return months + " months ago"
      } else if (days <= 545) {
        return "a year ago"
      } else {
        // (days > 545)
        return years + " years ago"
      }
    },
    getClass(i) {
      switch (i) {
        case 0:
          return "first"
        case 1:
          return "second"
        case 2:
          return "third"
        default:
          return ""
      }
    },
    getPostEmoji() {
      const currentFeeling = this.typesOfFeelings.find(f => f.name === this.post.day_type.split(" ").reverse()[0])
      return require(`../../../assets/emojis/${currentFeeling ? currentFeeling.icon : "happy-40"}.png`)
    },
    postTypeString(type) {
      switch (type) {
        case "post":
          return "post"
        case "job":
          return "job opening"
        case "press":
          return "press release"
        case "event":
          return "event"
        case "question":
          return "question"
        case "poll":
          return "poll"
        default:
          return "post"
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.card_info {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #0f1734;
  margin: 0px;
  padding: 16px;
  .bold {
    font-weight: 700;
  }
}
.promoted-post-head {
  padding: 8px 16px;
  display: flex;
  align-items: center;
  font-size: 10px;
  font-weight: 700;
  div:first-child {
    transform: scale(0.1);
    width: 40px;
  }
  div:last-child {
    font-weight: 400;
    font-size: 10px;
    line-height: 12px;
    letter-spacing: 2px;
    text-transform: uppercase;
  }
}
.comment_count {
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  text-align: right;
  color: #0f1734;
  padding: 0px 16px 16px 16px;
  margin: 0px;
}
.card_footer {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px;
  .card_button {
    padding: 12px 24px;
    border-radius: 6px;
    width: fit-content;
    border: none;
    font-weight: 700;
    font-size: 14px;
  }
  .card_button2 {
    padding: 12px 24px;
    border-radius: 6px;
    width: fit-content;
    border: none;
    font-weight: 700;
    font-size: 14px;
    background: #e2e8f0;
    color: #47556e;
  }
}
.sub-text {
  font-size: 14px !important;
}
.post__tags {
  margin-bottom: 20px;
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  .tags {
    padding: 3px 16px;
    display: inline-block;
    font-weight: 700;
    font-size: 12px;
    line-height: 1.5;
  }
  .popover-button {
    line-height: 1em;
    button {
      background: none;
      border: none;
    }
  }
}

@media screen and (max-width: 600px) {
  .name-with-feeling {
    flex-direction: column;
    align-items: flex-start !important;

    .sub-text {
      margin-left: 0 !important;
      margin-bottom: 8px !important;
    }
  }
}
p.cp.text-capitalize {
  word-break: break-word;
}
.two-image-grid {
  grid-template-areas: "first" "second";
}
.more-image-grid {
  grid-template-areas: "first first" "first first" "second third";
}
.multiImgs {
  display: grid;
  img,
  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    background: white;
    max-height: 360px;
  }
  .position-relative {
    display: none;
  }
  .first {
    grid-area: first;
    max-height: 360px;
  }
  .second {
    grid-area: second;
  }
  .third {
    grid-area: third;
  }
  .first,
  .second,
  .third {
    display: block !important;
  }
  .more {
    background: #0f1734 !important;
    opacity: 0.6;
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0;
    // cursor: pointer;
  }
  .moreText {
    // cursor: pointer;
    font-weight: 700;
    position: absolute;
    font-size: 24px;
    line-height: 24px;
    color: #ffffff !important;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
.poll-tick {
  margin-top: 16px;
  background: #f1f5f9;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: #0f1734;
  border-radius: 5px;
  overflow: hidden;
  .vote-percent {
    height: 48px;
  }
}

.comment_container {
  padding: 16px;
  margin: 16px;
  background: rgba(255, 215, 204, 0.3);
  border-radius: 4px;
  .header {
    display: flex;
    align-items: center;
    .name {
      font-weight: 700;
      font-size: 16px;
      line-height: 24px;
      color: #0f1734;
      margin-bottom: 4px;
    }
  }
}
.comment-image {
  margin: 10px;
  margin-left: 52px;
  width: 100%;
  max-width: 200px;
  max-height: 150px;
  height: 100%;
  object-fit: contain;
}
.full_thread_container {
  display: flex;
  justify-content: flex-end;
  padding: 0px 16px 16px 16px;
  .full_thread {
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    margin: 0px;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/aboutCircle/ReportCard.vue